import { render, staticRenderFns } from "./HeaderInstaller.vue?vue&type=template&id=5a4057fb&scoped=true"
import script from "./HeaderInstaller.vue?vue&type=script&lang=js"
export * from "./HeaderInstaller.vue?vue&type=script&lang=js"
import style0 from "./HeaderInstaller.vue?vue&type=style&index=0&id=5a4057fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4057fb",
  null
  
)

export default component.exports